var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tactics main"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"ornament"}),_c('div',{staticClass:"matter"}),_c('div',{staticClass:"elliptical"}),_c('img',{staticClass:"code code-an",attrs:{"src":"https://image.xiaoxxx.cn/test/urlGather/202407162f97752246188e80497759.png","alt":""}})])])
}]

export { render, staticRenderFns }